import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FileStorageService, PhotoAreaService, TaskService } from '../../../../services';
import { JobScreenCommonService } from '../job-screen-common.service';
import { IGalleryImage } from '../../../job-control/job-screen-gallery.component';
import {
  JobScreenImageGalleryImage,
  JobScreenImageGalleryJob,
  JobScreenImageGalleryTask,
  JobScreenImageGalleryTaskStep,
} from '../../../../interfaces/screen-specific/job-screen';
import { ConfirmationService } from 'primeng/api';
import { Message } from '../../../../classes/Message';
import { IUploadResultDTO } from '../../../../interfaces/upload-result';
import { MessageService } from 'primeng';
import { StepType } from '../../../../interfaces/checklist/step-type';
import { PhotoAreaCondition, PhotoArea } from 'src/app/components/job-control/job-screen.component';
import { ITaskStepPhotoInfo } from '../../../../interfaces/task-info';
import { IPhotoArea } from '../../../../interfaces/photo-area';

@Component({
  selector: 'job-screen-image-gallery',
  templateUrl: './job-screen-image-gallery.component.html',
  styleUrls: ['./job-screen-image-gallery.component.scss'],
})
export class JobScreenImageGalleryComponent implements OnChanges, OnInit {
  @Input() taskId!: number;
  @Input() jobId!: number;
  @Input() organisationTypeId!: number;

  // images START
  pickupImages: IGalleryImage[] = [];
  dropoffImages: IGalleryImage[] = [];
  public areas: any[] = [];
  private photoAreas: IPhotoArea[];
  jobInfo: JobScreenImageGalleryJob;
  selectedTask: JobScreenImageGalleryTask;
  selectedImage: JobScreenImageGalleryImage;
  selectedCompleteTaskStep: JobScreenImageGalleryTaskStep;
  multipleFileUploadResult: IUploadResultDTO[] = [];
  selectedCondition: number;
  conditionComment: string;
  selectedImageSource: string = null;
  odometerImageSource: string = null;
  addPhotoDescription: string = null;
  progress: number;
  conditions = [
    { label: this.getConditionTitle(0), value: 0 },
    { label: this.getConditionTitle(1), value: 1 },
    { label: this.getConditionTitle(2), value: 2 },
    { label: this.getConditionTitle(3), value: 3 },
  ];
  public taskStepMultiPhotoInfo: ITaskStepPhotoInfo[] = [];
  isBusyAddPhotoToStep: any;
  isBusyUploadImage: any;
  files: {
    LastModifiedDate: Date;
  }[] = [];
  isBusySetAreaCondition: boolean;

  public get isAddEditPhotoDialogVisible(): boolean {
    return this.isShowAddPhotoToTaskStep || this.isShowEditPhotoToTaskStep;
  }

  public set isAddEditPhotoDialogVisible(val: boolean) {
    this.isShowAddPhotoToTaskStep = this.isShowEditPhotoToTaskStep = val;
    this.multipleFileUploadResult = [];
  }

  // Check for dialogs
  isShowAddPhotoToTaskStep: boolean;
  isShowEditPhotoToTaskStep: boolean;
  isShowSetAreaCondition: boolean;
  selectedArea: number = null;
  showOdometerImage: boolean;

  // Check for types

  constructor(
    private taskService: TaskService,
    private messageService: MessageService,
    private fileStorageService: FileStorageService,
    public commonService: JobScreenCommonService,
    public confirmationService: ConfirmationService,
    private photoAreaService: PhotoAreaService,
  ) {}

  ngOnInit(): void {
    this.loadPhotoAreas();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.taskId) {
      this.fetchTask();
    }
  }

  canAddPhoto(type: StepType) {
    if (this.organisationTypeId != 1 && this.organisationTypeId != 3) {
      return false;
    }

    let images: IGalleryImage[] = [];
    if (type == 1) {
      images = this.pickupImages;
    } else if (type == 3) {
      images = this.dropoffImages;
    }

    return (
      images.length > 0 || this.selectedTask?.completeTaskSteps?.some((t) => t.stepType == type)
    );
  }

  showAddPhotoToTaskStep(type: StepType) {
    this.isShowAddPhotoToTaskStep = true;
    this.selectedCompleteTaskStep = null;
    this.selectedImage = null;
    this.addPhotoDescription = null;

    let steps = this.selectedTask?.completeTaskSteps?.filter((x) => x.stepType == type);
    if (steps.length) {
      this.selectedCompleteTaskStep = steps[0];
      this.initAreas();
      if (this.areas.length) {
        this.selectedArea = this.areas[0].value;
      }
    }
    this.initFirstAreaCondition(type);
  }

  deletePhotoToTaskStep(image: IGalleryImage, stepType: StepType) {
    if (image) {
      this.confirmationService.confirm({
        message: `Are you sure want to delete the selected image?`,
        accept: () => {
          this.taskService.deletePhotoToTaskStep(image).then(() => {
            this.removeImageFromTaskSteps(this.selectedTask, image);

            if (stepType == StepType.PickupPhoto)
              this.updateImages(this.selectedTask, StepType.PickupPhoto, false);
            else if (stepType == StepType.DropOffPhoto)
              this.updateImages(this.selectedTask, StepType.DropOffPhoto, false);
          });
        },
      });
    }
  }

  showEditPhotoToTaskStep(image: JobScreenImageGalleryImage, type: StepType) {
    this.isShowEditPhotoToTaskStep = true;
    this.selectedImage = null;
    this.selectedImageSource = null;

    this.fileStorageService.getPreSignedURLs([image.source]).then((res) => {
      this.selectedImage = image;
      this.selectedImageSource = res.length ? res[0] : null;
      this.initAreaCondition(type);
    });
    this.addPhotoDescription = image.description;

    let steps = this.selectedTask?.completeTaskSteps?.filter((x) => x.stepType == type);
    if (steps.length) {
      this.selectedCompleteTaskStep = steps[0];
      this.initAreas();
      if (this.areas.length) {
        const item = this.areas.find((x) => x.value == image.area);
        this.selectedArea = item ? item.value : this.areas[0].value;
      }
    }
  }

  showOdometerPhoto(image: any) {
    this.showOdometerImage = true;
    this.odometerImageSource = null;

    this.fileStorageService.getPreSignedURLs([image.source]).then((res) => {
      this.odometerImageSource = res.length ? res[0] : null;
    });
  }

  showSetAreaCondition(event: any) {
    let type: StepType = event.type;
    this.selectedImage = event.image;

    this.isShowSetAreaCondition = true;

    this.initAreaCondition(type);
  }

  private fetchTask() {
    this.taskService
      .getForComponent(this.taskId, 'job-screen-image-gallery')
      .then((task: JobScreenImageGalleryTask) => {
        this.selectedTask = task;
        this.jobInfo = task.order.job;

        this.updateImages(task, StepType.PickupPhoto, true);
        this.updateImages(task, StepType.DropOffPhoto, true);
      });
  }

  initAreas() {
    this.selectedArea = null;
    this.areas = [];
    for (let i = 0; i < 7; i++) {
      this.areas.push({ label: this.getAreaTitle(i), value: i });
    }

    this.selectedTask.requiredPhotoAreas.forEach((x) => {
      this.areas.push({ label: this.getAreaTitle(x), value: x });
    });
  }

  loadPhotoAreas(): void {
    this.photoAreaService.getAll().then((areas) => {
      this.photoAreas = areas;
    });
  }

  getAreaTitle(area): string {
    return this.photoAreas.find((x) => x.area == area).description;
  }

  getConditionTitle(condition: number): string {
    switch (condition) {
      case 0:
        return 'Good Condition';
      case 1:
        return 'Minor Damage';
      case 2:
        return 'Major Damage';
      case 3:
        return 'Uninspected';
      case 4:
        return 'Not Required';
      default:
        return '';
    }
  }

  initFirstAreaCondition(type: StepType) {
    this.selectedCompleteTaskStep = null;
    this.areas = [];
    this.selectedArea = null;
    this.selectedCondition = null;
    this.conditionComment = null;

    let steps = this.selectedTask?.completeTaskSteps?.filter((x) => x.stepType == type);
    if (steps.length) {
      this.selectedCompleteTaskStep = steps[0];
      this.initAreas();
      if (this.areas.length) {
        this.selectedArea = this.areas[0].value;

        this.onAreaChange();
      }
    }

    this.refreshConditionComment();
  }

  removeImageFromTaskSteps(task: JobScreenImageGalleryTask, image: IGalleryImage) {
    if (image.isSignature) {
      let steps = task?.completeTaskSteps?.filter(
        (s) => StepType.PickupSignature == s.stepType || StepType.DropOffSignature == s.stepType,
      );
      steps.forEach((step) => {
        let photo = step.signatures.find((x) => x.id == image.id);

        if (photo) {
          let index = step.signatures.indexOf(photo, 0);
          if (index > -1) {
            step.signatures.splice(index, 1);
          }
        }
      });
    } else {
      let steps = task?.completeTaskSteps?.filter(
        (s) => StepType.PickupPhoto == s.stepType || StepType.DropOffPhoto == s.stepType,
      );

      steps.forEach((step) => {
        let photo = step.photos.find((x) => x.id == image.id);
        if (photo) {
          let index = step.photos.indexOf(photo, 0);
          if (index > -1) {
            step.photos.splice(index, 1);
          }
        }
      });
    }
  }

  private updateImages(
    task: JobScreenImageGalleryTask,
    stepType: StepType,
    clearCachedUrl: boolean,
  ) {
    switch (stepType) {
      case StepType.PickupPhoto:
        this.pickupImages = this.getImages(
          task,
          StepType.PickupPhoto,
          StepType.PickupSignature,
          clearCachedUrl,
        );
        break;
      case StepType.DropOffPhoto:
        this.dropoffImages = this.getImages(
          task,
          StepType.DropOffPhoto,
          StepType.DropOffSignature,
          clearCachedUrl,
        );
        break;
    }
  }

  private getImages(
    task: JobScreenImageGalleryTask,
    photoStepType: number,
    signatureStepType: number,
    clearCachedUrl: boolean,
  ): IGalleryImage[] {
    let images = [];

    if (task?.completeTaskSteps) {
      let steps = task.completeTaskSteps.filter((s) => photoStepType == s.stepType);

      if (steps.length) {
        let step = steps[0];

        step.photos.forEach((photo) => {
          let condition = null;
          let conditionComment = null;
          for (let i = 0; i < step.areas.length; i++) {
            if (photo.photoArea == step.areas[i].photoArea) {
              condition = step.areas[i].condition;
              conditionComment = step.areas[i].comment;
              break;
            }
          }

          images.push({
            id: photo.id,
            objectKey: photo.photoLocation,
            source: photo.photoLocation,
            isSignature: false,
            area: photo.photoArea,
            areaTitle: this.getAreaTitle(photo.photoArea),
            condition: condition,
            conditionTitle: this.getConditionTitle(condition),
            conditionComment: conditionComment,
            dateTime: photo.dateTime,
            clearCachedUrl: clearCachedUrl,
            extension: photo.extension,
            description: photo.description,
          });
        });
      }

      steps = task.completeTaskSteps.filter((s) => signatureStepType == s.stepType);
      if (steps.length) {
        let step = steps[0];
        let signatureTitle =
          signatureStepType == StepType.PickupSignature
            ? 'Pick-up Signature'
            : 'Drop-off Signature';
        step.signatures.forEach((photo) => {
          let condition = null;
          for (let i = 0; i < step.areas.length; i++) {
            if (photo.photoArea == step.areas[i].photoArea) {
              condition = step.areas[i].condition;
              break;
            }
          }

          images.push({
            id: photo.id,
            objectKey: photo.signatureLocation,
            source: photo.signatureLocation,
            isSignature: true,
            area: photo.photoArea,
            areaTitle: signatureTitle,
            dateTime: step.completedDateTime,
            extension: photo.extension,
          });
        });
      }
    }

    return images;
  }

  initAreaCondition(type: StepType) {
    this.selectedCompleteTaskStep = null;
    this.areas = [];
    this.selectedArea = null;
    this.selectedCondition = null;
    this.conditionComment = null;

    let steps = this.selectedTask.completeTaskSteps.filter((x) => x.stepType == type);
    if (steps.length) {
      this.selectedCompleteTaskStep = steps[0];
      this.initAreas();
      if (this.areas.length) {
        this.selectedArea = this.selectedImage
          ? this.areas.map((a) => a.value).find((a) => a == this.selectedImage.area)
          : this.areas[0].value;

        this.onAreaChange();
      }
    }
    this.selectedCondition = this.selectedImage ? this.selectedImage.condition : 0;
    this.refreshConditionComment();
  }

  onAreaChange() {
    let area = this.selectedCompleteTaskStep.areas.find((x) => x.photoArea == this.selectedArea);

    if (this.selectedArea == PhotoArea.FuelGaugeOdometer) {
      // Gauge
      this.conditions = [{ label: this.getConditionTitle(4), value: 4 }];
      this.selectedCondition = PhotoAreaCondition.NotRequired;
    } else if (this.selectedArea == PhotoArea.Additional) {
      // Additional
      this.conditions = [
        { label: this.getConditionTitle(0), value: 0 },
        { label: this.getConditionTitle(1), value: 1 },
        { label: this.getConditionTitle(2), value: 2 },
        { label: this.getConditionTitle(3), value: 3 },
        { label: this.getConditionTitle(4), value: 4 },
      ];

      this.selectedCondition = area ? area.condition : PhotoAreaCondition.Good;
    } else {
      this.conditions = [
        { label: this.getConditionTitle(0), value: 0 },
        { label: this.getConditionTitle(1), value: 1 },
        { label: this.getConditionTitle(2), value: 2 },
        { label: this.getConditionTitle(3), value: 3 },
      ];

      this.selectedCondition = area ? area.condition : PhotoAreaCondition.Good;
    }
    this.refreshConditionComment();
  }

  refreshConditionComment() {
    this.conditionComment = null;
    let area = this.selectedCompleteTaskStep.areas.find(
      (x) => x.photoArea == this.selectedArea && x.condition == this.selectedCondition,
    );
    if (area) {
      this.conditionComment = area.comment;
    }
  }

  closeAddPhotoToTaskStep() {
    this.isShowAddPhotoToTaskStep = false;
    this.isShowEditPhotoToTaskStep = false;
    this.multipleFileUploadResult = [];
  }

  onConditionChange() {
    this.refreshConditionComment();
  }

  progressUploading(event) {
    this.progress = event.progress;
  }

  onBeforeUpload(event) {
    this.isBusyAddPhotoToStep = true;
    let lmDate = this.files[0].LastModifiedDate;
    if (!lmDate) lmDate = new Date();

    event.formData.append('lastModifiedDate', lmDate.getTime());
    event.formData.append('size', '400');
    event.formData.append(
      'area',
      this.selectedArea || this.selectedArea == 0 ? this.selectedArea : 6,
    );
    event.formData.append('description', this.addPhotoDescription ? this.addPhotoDescription : '');
    event.formData.append('jobId', this.jobId);
    event.formData.append('taskId', this.selectedTask.id);
  }

  onError(event: { files: any[] }) {
    let errorDescripton = 'The following files were not be uploaded: <br/>';
    if (event.files.length > 0) {
      for (let file of event.files) {
        errorDescripton += file.name + '<br/>';
      }
    }
    this.isBusyAddPhotoToStep = false;

    this.messageService.add(
      Message.Error(
        'An error occurred while uploading files.Please try again.<br />' + errorDescripton,
        'File Uploading',
      ),
    );
  }

  onSelect(event) {
    this.files = [];
    if (event.files.length > 0) {
      for (let file of event.files) {
        let fileDetails = {
          LastModifiedDate: file.lastModifiedDate,
          Name: file.name,
          Size: file.size,
          Type: file.type,
        };
        this.files.push(fileDetails);
      }
    }
  }

  onMultipleFileUpload(event) {
    let response = event.originalEvent.body;
    if (response) {
      for (let i = 0; i < response.length; i++) {
        this.multipleFileUploadResult.push(response[i]);
      }
    }
    this.isBusyAddPhotoToStep = false;
  }

  async saveMultiplePhotosOnStep() {
    if (this.isShowAddPhotoToTaskStep) this.addMultiplePhotosToStep();
    else await this.updatePhotoToStep();

    this.setAreaCondition();
  }

  isConditionCommentValid() {
    if (
      this.selectedCondition == PhotoAreaCondition.Good ||
      this.selectedCondition == PhotoAreaCondition.NotRequired
    ) {
      return true;
    } else {
      return this.conditionComment != null && this.conditionComment != '';
    }
  }

  async updatePhotoToStep() {
    this.isBusyAddPhotoToStep = true;

    let updatedImage = Object.assign({}, this.selectedImage);

    updatedImage.description = this.addPhotoDescription;
    updatedImage.photoArea = this.selectedArea;

    try {
      await this.taskService.updatePhotoToTaskStep(updatedImage);

      this.selectedImage.description = this.addPhotoDescription;
      this.selectedImage.area = this.selectedArea;
      this.selectedImage.areaTitle = this.getAreaTitle(this.selectedImage.area);

      let area = this.selectedCompleteTaskStep.areas.find((x) => x.photoArea == this.selectedArea);
      if (this.selectedArea == PhotoArea.FuelGaugeOdometer) {
        this.selectedImage.condition = PhotoAreaCondition.NotRequired;
      } else {
        this.selectedImage.condition = area ? area.condition : PhotoAreaCondition.Good;
      }

      //Need update task due do updateImages();
      this.updatePhotoOrSignatureData(this.selectedTask, this.selectedImage);

      this.updateImages(this.selectedTask, this.selectedCompleteTaskStep.stepType, false);

      this.isBusyAddPhotoToStep = false;
      this.isShowAddPhotoToTaskStep = false;
      this.isShowEditPhotoToTaskStep = false;
      this.messageService.add(Message.Success('Photo successfully updated.', 'Update Photo Data'));
    } catch (ex) {
      this.isBusyAddPhotoToStep = false;
      console.log(ex);
      this.messageService.add(
        Message.Error(
          'An error occurred while updating the photo. Try again.',
          'Update Photo Data',
        ),
      );
    }
  }

  updatePhotoOrSignatureData(task: JobScreenImageGalleryTask, image: JobScreenImageGalleryImage) {
    if (image.isSignature) {
      let steps = task.completeTaskSteps.filter(
        (s) => StepType.PickupSignature == s.stepType || StepType.DropOffSignature == s.stepType,
      );
      steps.forEach((step) => {
        let photo = step.signatures.find((x) => x.id == image.id);

        if (photo) {
          photo.photoArea = image.area;
          for (let i = 0; i < step.areas.length; i++) {
            if (step.areas[i].photoArea == image.area) {
              step.areas[i].condition = image.condition;
              break;
            }
          }
        }
      });
    } else {
      let steps = task.completeTaskSteps.filter(
        (s) => StepType.PickupPhoto == s.stepType || StepType.DropOffPhoto == s.stepType,
      );

      steps.forEach((step) => {
        let photo = step.photos.find((x) => x.id == image.id);
        if (photo) {
          photo.description = image.description;
          photo.photoArea = image.area;
          for (let i = 0; i < step.areas.length; i++) {
            if (step.areas[i].photoArea == image.area) {
              step.areas[i].condition = image.condition;
              break;
            }
          }
        }
      });
    }
  }

  addMultiplePhotosToStep() {
    if (
      this.selectedArea == null ||
      this.selectedCompleteTaskStep == null ||
      this.multipleFileUploadResult.length <= 0
    )
      return;

    this.isBusyAddPhotoToStep = true;

    for (let i = 0; i < this.multipleFileUploadResult.length; i++) {
      let photoInfo = {} as ITaskStepPhotoInfo;
      photoInfo.taskId = this.selectedTask.id;
      photoInfo.taskStepId = this.selectedCompleteTaskStep.id;
      photoInfo.photoArea = this.multipleFileUploadResult[i].area;
      photoInfo.photoLocation = this.multipleFileUploadResult[i].fileData.guid;
      photoInfo.description = this.multipleFileUploadResult[i].description;
      this.taskStepMultiPhotoInfo.push(photoInfo);
    }

    this.taskService
      .AddMultiplePhotosToTaskStep(this.taskStepMultiPhotoInfo)
      .then((result) => {
        this.isBusyAddPhotoToStep = false;
        this.isShowAddPhotoToTaskStep = false;
        this.isShowEditPhotoToTaskStep = false;

        for (let i = 0; i < result.length; i++) {
          this.selectedCompleteTaskStep.photos.push({
            photoArea: result[i].photoTaskStep.photoArea,
            dateTime: result[i].photoTaskStep.dateTime,
            description: result[i].photoTaskStep.description,
            photoLocation: result[i].photoTaskStep.photoLocation,
            taskStepId: this.selectedCompleteTaskStep.id,
            id: result[i].photoTaskStep.id,
            extension: result[i].photoTaskStep.extension,
          });

          let area = this.selectedCompleteTaskStep.areas.find(
            (x) => x.photoArea == result[i].photoTaskStep.photoArea,
          );
          if (!area) {
            this.selectedCompleteTaskStep.areas.push({
              id: 0,
              condition: 0, // we have been asked to set it to Good by default.
              photoArea: result[i].photoTaskStep.photoArea,
              taskStepId: this.selectedCompleteTaskStep.id,
              dateTime: new Date(),
              comment: null,
            });
          }
        }
        this.updateImages(this.selectedTask, this.selectedCompleteTaskStep.stepType, false);

        this.selectedArea = null;
        this.multipleFileUploadResult = [];
        this.taskStepMultiPhotoInfo = [];
        this.addPhotoDescription = null;

        this.messageService.add(Message.Success('Photo successfully added.', 'Add Photo To Step'));
      })
      .catch(() => {
        this.isBusyAddPhotoToStep = false;
        this.messageService.add(
          Message.Error(
            'An error occurred while adding the photo to task. Try again.',
            'Add Photo To Step',
          ),
        );
      });
  }

  setAreaCondition() {
    if (this.selectedArea == null || this.selectedCondition == null) {
      return;
    }

    this.isBusySetAreaCondition = true;

    this.taskService
      .setAreaCondition({
        taskId: this.selectedTask.id,
        taskStepId: this.selectedCompleteTaskStep.id,
        photoArea: this.selectedArea,
        condition: this.selectedCondition,
        comment: this.conditionComment,
      })
      .then(() => {
        this.isBusySetAreaCondition = false;
        this.isShowSetAreaCondition = false;

        let area = this.selectedCompleteTaskStep.areas.find(
          (x) => x.photoArea == this.selectedArea,
        );
        if (area) {
          area.condition = this.selectedCondition;
          area.comment = this.conditionComment;
        } else {
          this.selectedCompleteTaskStep.areas.push({
            id: 0,
            condition: this.selectedCondition,
            photoArea: this.selectedArea,
            taskStepId: this.selectedCompleteTaskStep.id,
            dateTime: new Date(),
            comment: this.conditionComment,
          });
        }

        this.updateImages(this.selectedTask, this.selectedCompleteTaskStep.stepType, false);

        this.selectedArea = null;
        this.selectedCondition = null;

        this.messageService.add(
          Message.Success('Condition successfully changed.', 'Set Area Condition'),
        );
      })
      .catch(() => {
        this.isBusySetAreaCondition = false;
        this.messageService.add(
          Message.Error(
            'An error occurred while changing the condition for area. Try again.',
            'Set Area Condition',
          ),
        );
      });
  }

  closeSetAreaCondition() {
    this.isShowSetAreaCondition = false;
  }

  odometerDialogVisibleChanged(visible: boolean) {
    this.showOdometerImage = visible;
  }
}
